<template>
  <div class="app-container">
    <header class="app-header">
      <div class="header-content">
        <router-link to="/" class="logo-link">
          <img src="/noetiqicon.png" alt="Logo" class="logo-icon" />
        </router-link>
      </div>
    </header>

    <main class="app-main">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "./styles/global.css";
</style>

<style scoped>
.app-container {
  min-height: 100vh;
  background: #fafafa;
}

.app-header {
  background: #ffffff;
  border-bottom: 1px solid #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 50;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.logo-link:hover {
  opacity: 0.7;
}

.logo-icon {
  width: 32px;
  height: 32px;
  opacity: 0.9;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 500;
  color: #1a1a1a;
  letter-spacing: -0.01em;
}

.app-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

@media (max-width: 768px) {
  .header-content {
    padding: 0.875rem 1rem;
  }

  .logo-icon {
    width: 28px;
    height: 28px;
  }

  .logo-text {
    font-size: 1.125rem;
  }

  .app-main {
    padding: 0 1rem;
  }
}
</style>
